import React from "react";
import { InfoOutlined } from "@material-ui/icons";

export const BannerNoteChip = ({ text }: { text: string }) => {
  return (
    <div className="tw-bg-[#E5F0FF] tw-flex tw-items-center tw-gap-[6px] tw-p-[10px]">
      <InfoOutlined className="tw-w-[12px] tw-h-[12px] tw-text-[#272522d9] -tw-mt-2" />
      <div className="tw-text-[rgba(39,37,34,0.85)] tw-text-[12px] tw-font-normal tw-leading-[16px] tw-tracking-[0.24px]">
        {text}
      </div>
    </div>
  );
};
